export const randomFromEnum = (e: any) : string => {
    let numValues = Object.values(e).length
    let randomIndex = Math.floor(Math.random() * numValues)
    return Object.values(e)[randomIndex] as unknown as string
}